import React, { Component } from "react";
import QRCode from "react-qr-code";
import { Link } from "react-router-dom";
import { mainWebsite } from "./../../../Utils/endpoints";
import ReactToPrint from "react-to-print";

class EmployeeLoginQr extends Component {
  state = {};
  render() {
    return (
      <div>
        <QR ref={(el) => (this.componentRef = el)} />

        <div className="text-center">
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-red mb-4">Print this out!</button>
            )}
            content={() => this.componentRef}
          />
        </div>
      </div>
    );
  }
}

export default EmployeeLoginQr;
class QR extends Component {
  render() {
    return (
      <div class="block shadow">
        <div class="block-header bg-header-red">
          <h3 class="block-title text-white">Employee Login</h3>
        </div>
        <div class="block-content block-content-full text-center">
          <QRCode value={mainWebsite} size={450} />
        </div>
        <div className="text-center">
          <Link to="#" onClick={() => (window.location.href = mainWebsite)}>
            <b>Employee</b>
          </Link>
        </div>
      </div>
    );
  }
}
